var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 19",
    width: 12,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-18-49h428v6281h-428z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#f457b0}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1 10c0-0.4 0.2-0.7 0.4-0.9l7.7-7.7c0.2-0.3 0.6-0.4 0.9-0.4 0.7 0 1.3 0.6 1.3 1.3 0 0.3-0.2 0.6-0.4 0.9l-6.8 6.8 6.7 6.7c0.3 0.3 0.5 0.6 0.5 1 0 0.7-0.6 1.3-1.3 1.3-0.3 0-0.7-0.1-0.9-0.4l-7.7-7.7c-0.2-0.2-0.4-0.5-0.4-0.9q0 0 0 0 0 0 0 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.29cb4e70bd3ca029d0ee96fc3c0bd51a.svg";
export { ForwardRef as ReactComponent };